import { render, staticRenderFns } from "./EditarConteudo.vue?vue&type=template&id=377d9be8&scoped=true&"
import script from "./EditarConteudo.vue?vue&type=script&lang=js&"
export * from "./EditarConteudo.vue?vue&type=script&lang=js&"
import style0 from "./EditarConteudo.vue?vue&type=style&index=0&id=377d9be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d9be8",
  null
  
)

export default component.exports